module.exports = __webpack_public_path__ + "static/media/transaction_successfull.4788266b.png";